import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'heightmaps',
    path: '/heightmaps',
    component: () => import('../pages/HeightmapsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'heightmapWizard',
    path: '/heightmaps/wizard',
    component: () => import('../pages/HeightmapWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
